import React, { useEffect, useState } from "react";

import api, { handleApi } from "pages/api/api";
import { useAuth } from "pages/context/AuthContext";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import Draggable from "react-draggable";

function PaperComponent(props) {
  return (
    <Draggable handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function DialogObjetivoV2SubmarcaFaturas({ open, onClose, idObjetivo, detalhe }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { userData } = useAuth();

  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState("");

  useEffect(() => {
    if (!open || !idObjetivo || !detalhe?.refcliente || !detalhe?.refsubmarca) {
      setDados(null);
      setErro("");
      return;
    }

    let ativo = true;

    const carregar = async () => {
      setLoading(true);
      setErro("");

      try {
        const [data, err] = await handleApi(
          api.post("Comercial/SelObjetivoV2SubmarcaFaturas", {
            idobjetivo: idObjetivo,
            refcliente: detalhe.refcliente,
            refsubmarca: detalhe.refsubmarca,
            refssubmarca: Array.isArray(detalhe?.refssubmarca) ? detalhe.refssubmarca : [],
            idutilizador: userData?.id || 0,
          })
        );

        if (!ativo) return;

        if (err) {
          setDados(null);
          setErro(err);
          return;
        }

        setDados(data || null);
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    };

    carregar();

    return () => {
      ativo = false;
    };
  }, [open, idObjetivo, detalhe?.refcliente, detalhe?.refsubmarca, userData?.id]);

  const faturas = Array.isArray(dados?.faturas) ? dados.faturas : [];

  const columns = [
    {
      Header: "Data",
      accessor: "faturadata",
      width: 110,
      minWidth: 105,
      Cell: ({ value }) => (value ? String(value).slice(0, 10) : ""),
    },
    {
      Header: "Fatura",
      accessor: "faturanumero",
      width: 150,
      minWidth: 130,
    },
    {
      Header: "Quantidade",
      accessor: "qtd",
      width: 120,
      minWidth: 110,
      align: "right",
      headerAlign: "right",
      sortType: "numPt",
      Cell: ({ value }) =>
        Number(value || 0).toLocaleString("pt-PT", {
          maximumFractionDigits: 3,
        }),
    },
    {
      Header: "Vendedor",
      accessor: "vendedor",
      width: 220,
      minWidth: 180,
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      fullScreen={isMobile}
      PaperComponent={isMobile ? undefined : PaperComponent}
      PaperProps={{
        sx: {
          width: {
            xs: "100%",
            sm: "calc(100% - 48px)",
          },
          maxHeight: {
            xs: "100%",
            sm: "90vh",
          },
        },
      }}
    >
      <DialogTitle
        className="draggable-dialog-title"
        sx={{
          cursor: {
            xs: "default",
            sm: "move",
          },
        }}
      >
        <MDTypography variant="h5">
          {detalhe?.submarca || detalhe?.refsubmarca || "Submarca"}
        </MDTypography>
      </DialogTitle>

      <DialogContent dividers>
        {loading && (
          <MDBox py={4} display="flex" justifyContent="center">
            <CircularProgress />
          </MDBox>
        )}

        {!loading && erro && (
          <MDBox py={2}>
            <MDTypography variant="button" color="error">
              {erro}
            </MDTypography>
          </MDBox>
        )}

        {!loading && !erro && (
          <ProjectTable
            tableKey="objetivo-v2-submarca-faturas"
            version="v1"
            columns={columns}
            data={faturas}
            loading={false}
            emptyMessage="Sem faturas para apresentar."
            minWidth={650}
            maxHeight={isMobile ? "calc(100vh - 220px)" : "55vh"}
          />
        )}
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
